// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-activate',
    data: () => ({
        userID: "",
        codeConfirmed: "",
        errorMessage: "",
        isLoading: false
    }),
    created() {
        // #region Data
        this.userID = this.$route.params.userId;
        // #endregion
        // #region Check
        if (!this.$route.params.userId) {
            this.$router.push({ name: 'login' });
            return;
        }
        // #endregion
        // #region Load
        let config = {
            params: {
                userId: this.userID
            },
        };
        host.api.get("identity/profile/activate", config)
            .then((e) => {
            this.userID = e.data.userid;
        })
            .catch((e) => {
            this.errorMessage = utils.getAxiosErrorMessage(e);
        });
        // #endregion
    },
    watch: {
        code: function (val) {
            if (utils.isNullOrEmpty(this.userID)) {
                return;
            }
            this.errorMessage = '';
        },
    },
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isNullOrEmpty(this.userID) || utils.isNullOrEmpty(this.codeConfirmed);
        }
    },
    methods: {
        OnSubmit(e) {
            //Default
            e.preventDefault();
            //Run
            this.execute();
        },
        execute() {
            // #region Check
            if (utils.isNullOrEmpty(this.userID)) {
                return;
            }
            if (utils.isEmpty(this.codeConfirmed)) {
                return;
            }
            if (this.isLoading) {
                return;
            }
            // #endregion
            // #region Vars
            this.isLoading = false;
            // #endregion
            // #region Reset
            this.errorMessage = "";
            // #endregion
            // #region Run
            let tData = {
                userId: this.userID,
                codeConfirmed: this.codeConfirmed,
                xrsfToken: this.$route.params.xrsfToken
            };
            host.login.activate(tData)
                .then(e => {
                // #region Data
                if (!e.isSucceded) {
                    this.errorMessage = e.errorMessage;
                }
                else if (this.$route.query?.returnUrl) {
                    this.$router.push(decodeURIComponent(this.$route.query?.returnUrl));
                }
                else {
                    this.$router.push("/");
                }
                // #endregion
                // #region local
                this.isLoading = false;
                // #endregion
            })
                .catch(e => {
                // #region local
                this.isLoading = false;
                // #endregion
            });
            // #endregion
        }
    }
});
// #endregion
